module.exports = __webpack_public_path__ + "img/vue-logo.65a7f974.jpg";